import React from "react";

const DurationRangeError = props => (
  <span className="duration-range-error hidden">
    Duration must fall between 00:01 - 10:00.
  </span>
);

export default DurationRangeError;
